import { ReloadOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

import { Button } from "@av/components/atoms/Button";

import type { TFunction } from "i18next";

type EmailRetryButtonProps = {
  t: TFunction;
  testIdPrefix: string;
  testIdValue: string;
  userName: string;
  isSending: boolean;
  disabled: boolean;
  onRetry: () => void;
};

export function EmailRetryButton({
  t,
  testIdPrefix,
  testIdValue,
  userName,
  isSending,
  disabled,
  onRetry,
}: EmailRetryButtonProps) {
  return (
    <Tooltip
      title={
        <span data-testid={`${testIdPrefix}-email-status-retry-${testIdValue}-tooltip`}>
          {t("platform.adminSettings.users_emailStatus_retry")}
        </span>
      }
      trigger={["hover", "focus"]}
    >
      <Button
        // Names the person, like the row's edit button, so screen readers can tell the rows apart
        aria-label={t("platform.adminSettings.users_emailStatus_retryLabel", { name: userName })}
        disabled={disabled}
        icon={<ReloadOutlined spin={isSending} />}
        size="small"
        testIdPrefix={`${testIdPrefix}-email-status-retry-${testIdValue}`}
        type="link"
        onClick={onRetry}
      />
    </Tooltip>
  );
}
